import { z } from 'zod';
import { BaseValidations } from '@anytag/shared-validations';

export const ProposeInfluencersBulkEditSchema = z.object({
  budget: BaseValidations.IntegerSchema.or(z.literal('')),
  influencerCost: BaseValidations.IntegerSchema.or(z.literal(''))
});
